import axios from "./axios-header";

export const trackVisits = async () => {
  const response = await axios.post("/track-visit");
  return response.data;
};

export const getVisitReport = async () => {
  const response = await axios.get("/visit-report");
  return response.data;
};

export const getChildLocation = async (parentCode) => {
  const response = await axios.post('track-location', parentCode);
  return response.data;
}

export const generateOTP = async (email) => {
  const response = await axios.post('generate-otp', email);
  return response.data;
}

export const verifyOTP = async (data) => {
  const response = await axios.post('verify-otp', data);
  return response.data;
}

export const fetchType = async (code) => {
  const response = await axios.get(`fetch-type/${code}`);
  return response.data;
}

// add request accounts and organizations ==========================
export const publicOrganization = async (params = {}) => {
  const response = await axios.get('public-organization', { params });
  return response.data;
}

export const addRequestAccount = async (data) => {
  const response = await axios.post('add-request-account', data);
  return response.data;
}

export const addRequestOrganization = async (data) => {
  const response = await axios.post('add-request-organization', data);
  return response.data;
}

export const login = async (data) => {
  const response = await axios.post("/login", data);
  return response.data;
};

export const logout = async () => {
  const response = await axios.post("/logout");
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await axios.post("/forgot-password", { email });
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await axios.post("/reset-password", data);
  return response.data;
};
